import api from '../../services/attendance';
export default function (helper) {
  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('attendance');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'Attendance');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}